// extracted by mini-css-extract-plugin
export default {"dropView":"styles_dropView__mckoZ","options":"styles_options__gCATU"};